import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { AdminComponent } from '../admin/admin.component';

@Component({
  selector: 'app-signout',
  templateUrl: './signout.component.html',
  styleUrls: ['./signout.component.css']
})
export class SignoutComponent implements OnInit {

  messageInfo : string = "Are you sure you want to Logout?";
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AdminComponent>
  ) {

  }

  ngOnInit() {
    this.messageInfo = this.data.info;
  }
  submit() {
    this.dialogRef.close(true)
  }
  close() {
    this.dialogRef.close(false)
  }

}
